/**
 * Triggers a browser download by clicking a synthetic anchor.
 *
 * Shared by the report screens, which download from a pre-signed URL, and the claim form downloads,
 * which fetch bytes with the user's access token and hand over a blob.
 */
function clickDownloadAnchor(href: string, filename?: string): void {
  const anchor = document.createElement('a')
  anchor.href = href
  if (filename) {
    anchor.download = filename
  }

  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}

/** Downloads from a URL the browser can fetch on its own, e.g. a signed report URL. */
export function downloadFromUrl(url: string, filename?: string): void {
  clickDownloadAnchor(url, filename)
}

/**
 * Saves an already-fetched blob under a given filename.
 *
 * Used for endpoints whose bytes need the caller's access token, so they cannot be handed to the
 * browser as a bare URL the way signed report URLs are.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const objectUrl = URL.createObjectURL(blob)

  try {
    clickDownloadAnchor(objectUrl, filename)
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}
